import { useDispatch } from 'react-redux';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { actionShowModal } from '../../../actions/modal';
import { ModalTypes } from '../../../reducers/modal';
import useDevice from '../../../pages/MainPage/useMobileDetect';

import './styles.scss';

interface IReferralModalProps {
  onCancel: () => void;
}

const ReferralModal = ({ onCancel }: IReferralModalProps) => {
  const dispatch = useDispatch();
  const { isMobile } = useDevice();

  const onConnect = () => {
    dispatch(actionShowModal(ModalTypes.connect, {}));
  };

  return (
    <div className='referral_modal'>
      <div className='referral_modal__content'>
        {isMobile ? (
          <>
            <Text size={14} className='referral_modal__content__header'>
              🎉 Welcome 🎉
            </Text>
            <Text size={14} className='referral_modal__content__body'>
              You&#39;ve been invited by another user to join us! Connect your
              wallet to unlock bonuses for both of you. Let&#39;s get started!
            </Text>
          </>
        ) : (
          <>
            <Text size={14} className='referral_modal__content__header'>
              🎉 Welcome to our Referral Program! 🎉
            </Text>
            <Text size={14} className='referral_modal__content__body'>
              You&#39;ve arrived with a special referral ID, which means you
              were invited by another user to join our community. We&#39;re
              excited to have you onboard!
              <br />
              <br />
              By connecting your wallet using this referral link, both you and
              the user who referred you will receive amazing bonuses as a token
              of our gratitude. It&#39;s a win-win situation!
              <br />
              <br />
              Our referral program is designed to reward our valued users for
              spreading the word about our platform.
              <br />
              <br />
              Sharing your referral link with friends, family, or anyone
              interested can unlock incredible benefits for everyone involved.
              <br />
              <br />
              Happy exploring,
              <br />
              Kattana team!
            </Text>
          </>
        )}
        <div className='referral_modal__content__btn'>
          <Button
            action={onConnect}
            variant='primary'
            size='s'
            text='Connect wallet'
          />
        </div>
      </div>
    </div>
  );
};

export default ReferralModal;